import ConditionalRender from "../../../ConditionalRender"
import { InputBox } from "../../../design_system/components/Input Fields/InputBox.jsx"
import { SelectBox } from "../../../design_system/components/Input Fields/SelectBox.jsx"

// Default range conditions shared by remaining filter callers.
export const CONDITIONS = [
    {key: 'Above', label: 'Above'},
    {key: 'Below', label: 'Below'},
    {key: 'Between', label: 'Between'},
    {key: 'Equal', label: 'Equal'},
]

export const CommonRangeFilter = ({
    range_filter,
    setRangeFilter,
    conditions = CONDITIONS,
    minRange,
    maxRange,
    layout = 'default',
    customLabel = 'Condition',
    Size = 'Small',
}) => {
    const handleConditionChange = (cond) => {
        setRangeFilter({ ...range_filter, cond, min: '', max: '' })
    }

    const handleMinChange = (value) => {
        const updated = { ...range_filter }
        switch (updated.cond) {
            case "Above":   updated.min = value; updated.max = maxRange; break
            case "Below":   updated.min = minRange; updated.max = value; break
            case "Between": updated.min = value; break
            case "Equal":   updated.min = value; updated.max = value; break
        }
        setRangeFilter(updated)
    }

    const handleMaxChange = (value) => {
        setRangeFilter({ ...range_filter, max: value })
    }

    const minValue = range_filter.cond === 'Below' ? range_filter.max : range_filter.min
    const minPlaceholder = range_filter.cond === 'Between' ? 'From' : '50'
    const conditionOptions = conditions.map(c => ({ label: c.label, value: c.key }))

    const renderConditionSelect = (style) => (
        <SelectBox
            label={customLabel}
            showLabel
            Size={Size}
            value={range_filter.cond}
            options={conditionOptions}
            handleOnChange={handleConditionChange}
            customStyle={style}
            variant="ghost"
            triggerStyle={{ border: '1px solid var(--color-border-default)' }}
        />
    )

    const renderMaxInput = (style) => (
        <ConditionalRender if={range_filter.cond === 'Between'}>
            <div className="range-common__between-row flex items-center">
                <span className="body-m range-common__separator">-</span>
                <InputBox Size={Size} customStyle={style}>
                    <input type="text" value={range_filter.max} onChange={(e) => handleMaxChange(e.target.value)} placeholder="To"/>
                </InputBox>
            </div>
        </ConditionalRender>
    )

    if (layout === 'Horizontal') return (
        <div className="range-common__row flex items-end">
            {renderConditionSelect({ maxWidth: '162px', width: '100%' })}
            <div className="range-common__inputs-wrap flex items-end">
                <InputBox Size={Size} customStyle={{ width: '70px' }}>
                    <input type="text" value={minValue} onChange={(e) => handleMinChange(e.target.value)} placeholder={minPlaceholder}/>
                </InputBox>
                {renderMaxInput({ width: '70px' })}
            </div>
        </div>
    )

    return (
        <div style={{ margin: '16px 0' }}>
            {renderConditionSelect({ maxWidth: '162px', width: '100%' })}
            <div className="range-common__inputs-row flex items-end">
                <InputBox Size={Size} label="Value" showLabel customStyle={{ maxWidth: '144px', marginTop: '16px' }}>
                    <input type="text" value={minValue} onChange={(e) => handleMinChange(e.target.value)} placeholder={minPlaceholder}/>
                </InputBox>
                {renderMaxInput({ maxWidth: '144px' })}
            </div>
        </div>
    )
}
